import { CarouselType, FeedOptions, FeedProperty } from '@/types/models'
export const DEFAULT_LOCAL_BLOCK_MAX_ITEMS = 70
export const DEFAULT_FEED_LAYOUT: FeedProperty[] = [
  {
    feedType: FeedOptions.Local,
    maxItems: DEFAULT_LOCAL_BLOCK_MAX_ITEMS
  },
  {
    feedType: FeedOptions.Carousel,
    itemType: CarouselType.TopLocations,
    positionStart: 3
  },
  { feedType: FeedOptions.MidFeed, maxItems: 1 },
  {
    feedType: FeedOptions.Carousel,
    itemType: CarouselType.Insurance,
    positionStart: 16
  },
  {
    feedType: FeedOptions.Carousel,
    itemType: CarouselType.NationWide,
    positionStart: 16
  },
  { feedType: FeedOptions.FilterWizard, positionStart: 20 },
  {
    feedType: FeedOptions.Organic,
    maxItems: 90,
    inFeed: { repeatEvery: 4, feedSource: FeedOptions.MidFeed }
  },
  {
    feedType: FeedOptions.Nearby,
    maxItems: 20,
    inFeed: { repeatEvery: 4, feedSource: FeedOptions.MidFeed }
  }
]

export const LOCATION_FEED_LAYOUT: FeedProperty[] = [
  {
    feedType: FeedOptions.Local,
    maxItems: DEFAULT_LOCAL_BLOCK_MAX_ITEMS
  },
  {
    feedType: FeedOptions.Carousel,
    itemType: CarouselType.TopLocations,
    positionStart: 3
  },
  { feedType: FeedOptions.MidFeed, maxItems: 1 },
  {
    feedType: FeedOptions.Organic,
    maxItems: 3
  },
  {
    feedType: FeedOptions.Explore,
    maxItems: 1
  },
  {
    feedType: FeedOptions.Carousel,
    itemType: CarouselType.Insurance,
    positionStart: 16
  },
  { feedType: FeedOptions.FilterWizard, positionStart: 20 },

  {
    feedType: FeedOptions.Organic,
    maxItems: 90,
    inFeed: { repeatEvery: 4, feedSource: FeedOptions.MidFeed }
  },
  {
    feedType: FeedOptions.Nearby,
    maxItems: 20,
    inFeed: { repeatEvery: 4, feedSource: FeedOptions.MidFeed }
  }
]

export const ZERO_LOCATION_LAYOUT: FeedProperty[] = [
  {
    feedType: FeedOptions.Nearby,
    maxItems: 20,
    inFeed: { repeatEvery: 3, feedSource: FeedOptions.MidFeed }
  },
  {
    feedType: FeedOptions.Local,

    maxItems: 13
  }
]

export const TERM_FEED_LAYOUT: FeedProperty[] = [
  { feedType: FeedOptions.MidFeed, positionStart: 0, maxItems: 2 },
  {
    feedType: FeedOptions.Organic,
    positionStart: 3,
    maxItems: 80,
    inFeed: { repeatEvery: 3, feedSource: FeedOptions.MidFeed }
  },
  { feedType: FeedOptions.FilterWizard, positionStart: 20 },
  {
    feedType: FeedOptions.Carousel,
    itemType: CarouselType.Insurance,
    positionStart: 16
  }
]

export const singleInserts = [
  FeedOptions.FilterWizard,
  FeedOptions.Carousel,
  FeedOptions.Element,
  FeedOptions.NearbyHeader,
  FeedOptions.Destinations
]
